import { type FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const ParameterStabilityMock: FC = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
    <div className="p-3">
      <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faSliders} className="text-sm text-purple-400" />
            <h3 className="text-sm font-medium text-gray-300 uppercase tracking-wide">Parameter Stability</h3>
          </div>
          <span className="text-[10px] text-gray-500">90 combinations evaluated</span>
        </div>

        {/* Mini heatmap grid */}
        <div className="mb-4">
          <div className="flex items-end gap-2 mb-2">
            <span className="text-[9px] text-gray-500 w-16">slowLength</span>
            <div className="flex-1" />
          </div>
          <div className="flex gap-0.5">
            <div className="flex flex-col gap-0.5 justify-center mr-1">
              {[50, 40, 30, 20, 10].map(v => (
                <span key={v} className="text-[8px] text-gray-600 h-5 flex items-center">{v}</span>
              ))}
            </div>
            <div className="flex-1 grid grid-cols-9 gap-0.5">
              {[
                0.2, 0.3, 0.4, 0.3, 0.2, 0.1, 0.1, 0.0, 0.0,
                0.3, 0.5, 0.7, 0.6, 0.5, 0.3, 0.2, 0.1, 0.1,
                0.4, 0.7, 0.9, 0.85, 0.7, 0.5, 0.4, 0.3, 0.2,
                0.3, 0.6, 0.85, 0.95, 0.8, 0.6, 0.5, 0.3, 0.2,
                0.2, 0.4, 0.6, 0.7, 0.6, 0.4, 0.3, 0.2, 0.1,
              ].map((v, i) => (
                <div
                  key={i}
                  className="h-5 rounded-sm"
                  style={{
                    background: v > 0.8 ? `rgba(157,78,221,${0.5 + v * 0.4})` :
                      v > 0.5 ? `rgba(96,165,250,${0.3 + v * 0.4})` :
                        `rgba(107,114,128,${0.1 + v * 0.3})`,
                  }}
                />
              ))}
            </div>
          </div>
          <div className="flex items-center justify-between mt-1 ml-8">
            {[5, 10, 15, 20, 25, 30, 35, 40, 45].map(v => (
              <span key={v} className="text-[8px] text-gray-600">{v}</span>
            ))}
          </div>
          <div className="text-center mt-1">
            <span className="text-[9px] text-gray-500">fastLength</span>
          </div>
        </div>

        {/* Stability verdict */}
        <div className="flex items-center gap-3 px-3 py-2 rounded bg-emerald-500/10 border border-emerald-500/20">
          <FontAwesomeIcon icon={faCheckCircle} className="text-emerald-400" />
          <div>
            <div className="text-sm font-medium text-emerald-400">Stable Region Found</div>
            <div className="text-[11px] text-gray-400">12 parameter sets within 5% of peak &middot; Stability: 0.87</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ParameterStabilityMock;
